<template>
    <div class="block card">
        <div class="card-header">
            <div :class="'card-header-title has-text-light has-background-'+color+' clickable'" @click="goTo(task.id)">
                #{{task.id | makeIDSixDigits}}
            </div>
        </div>
        <div class="card-content has-background-white-ter">
            <div class="content">
                <p class="block">
                    Details: {{task.attributes.details}}
                </p>
                <p class="block">
                    App: {{task.attributes.app_id}}
                </p>
                <p class="block">
                    Developer: {{task.attributes.developer_id ? task.attributes.developer_id.email : 'N/A'}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        task: {
            type: Object
        },
        color: {
            type: String
        }
    },
    methods:{
        goTo(id){
            this.$router.push({
                name:'tickets.edit',
                params:{
                    id:id
                }
            })
        }
    }
}
</script>
<style scoped>
    .clickable{
        cursor: pointer;
    }
</style>